import { BrowserRouter, Routes, Route } from "react-router-dom";

import Web3Provider from "./providers/web3.provider";
import LayoutContainer from "./layout/layout";

import { Home } from "./pages/home/home";
import { VirtualHome } from "./pages/virtual/virtual";
import { DiscordCallback } from "./pages/discord-callback/discord-callback";
import { DiscordLink } from "./pages/discord-link/discord-link";
import { SelfExclude } from "./pages/self-exclude/Self-Exclude";
import { Deeplink } from "./pages/deeplink/deeplink";
import ClaimPage from "./pages/claim/ClaimPage";

require("@solana/wallet-adapter-react-ui/styles.css");

const App = () => {
	return (
		<Web3Provider>
			<BrowserRouter>
				<script src="https://cdn.tailwindcss.com"></script>

                                <Routes>
                                        <Route element={<LayoutContainer />}>
                                                <Route path="/" element={<Home />} />
                                                <Route path="/try" element={<VirtualHome />} />
                                                <Route path="/discord" element={<DiscordLink />} />
                                                <Route path="/discord/oauth" element={<DiscordCallback />} />
                                                <Route path="/deeplink" element={<Deeplink />} />
                                                <Route path="/self-exclude" element={<SelfExclude />} />
                                                <Route path="/claim" element={<ClaimPage />} />
                                        </Route>
                                </Routes>
			</BrowserRouter>
		</Web3Provider>
	);
}


export default App;
